import { Box, Grid } from '@mui/material'
import MUITooltip from '@mui/material/Tooltip'
import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import PinIcon from '../../Icons/PinIcon'
import './DashboardCard.scss'

type DashboardCardProps = {
  label: string
  count: number | string
  colorClass?: string
  link?: string | { pathname: string; search: string }
  onUnpin?: () => void
}

const DashboardCard: React.FC<DashboardCardProps> = ({
  label,
  count,
  colorClass = '',
  link = '',
  onUnpin,
}) => {
  const location = useLocation()

  const cardContent = (
    <div className={`dashboard-card ${colorClass}`}>
      <Box className='sub-heading-5 py-4 title d-flex justify-content-between align-items-center'>
        {label}
        {onUnpin && (
          <MUITooltip title='Unpin Widget' disableInteractive>
            <div
              data-testid={`pinnedId-${label}`}
              className='icon'
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                onUnpin()
              }}
            >
              <PinIcon />
            </div>
          </MUITooltip>
        )}
      </Box>
      <p className='heading-2 py-4'>{count}</p>
    </div>
  )

  return (
    <Grid item xs={4} className={`${link ? 'cursor-pointer ' : ''}card-padding`}>
      {link ? (
        <Link
          to={link}
          state={{ fromPage: location.pathname }}
          style={{ textDecoration: 'none' }}
          className='table-link'
          data-testid={`link-${label}`}
        >
          {cardContent}
        </Link>
      ) : (
        cardContent
      )}
    </Grid>
  )
}

export default DashboardCard
